'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CardPreview", {
    enumerable: true,
    get: function() {
        return CardPreview;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCardPreview = require("./useCardPreview");
const _renderCardPreview = require("./renderCardPreview");
const _useCardPreviewStylesstyles = require("./useCardPreviewStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CardPreview = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCardPreview.useCardPreview_unstable)(props, ref);
    (0, _useCardPreviewStylesstyles.useCardPreviewStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCardPreviewStyles_unstable')(state);
    return (0, _renderCardPreview.renderCardPreview_unstable)(state);
});
CardPreview.displayName = 'CardPreview';
